export default __webpack_public_path__ + "static/media/Product-List.f3b0a3ae.jpg";